import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import ServiceGrid from './components/ServiceGrid';
import ServiceArea from './components/ServiceArea';
import WhyChoose from './components/WhyChoose';
import RecentWork from './components/RecentWork';
import QuoteForm from './components/QuoteForm';
import { SchemaOrg, updateCanonical } from '../../utils/seo';

export default function HomePage() {
  useEffect(() => {
    updateCanonical('/');
  }, []);

  const localBusinessSchema = {
    name: 'Sooner Blacktop',
    image: 'https://example.com/logo.png',
    '@id': 'https://example.com',
    url: 'https://example.com',
    telephone: '',
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '',
      addressLocality: 'Oklahoma City',
      addressRegion: 'OK',
      postalCode: '',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 35.4676,
      longitude: -97.5164,
    },
    areaServed: [
      {
        '@type': 'City',
        name: 'Oklahoma City',
      },
      {
        '@type': 'City',
        name: 'Edmond',
      },
      {
        '@type': 'City',
        name: 'Norman',
      },
      {
        '@type': 'City',
        name: 'Moore',
      },
      {
        '@type': 'City',
        name: 'Yukon',
      },
    ],
    description: 'Professional parking lot striping, sealcoating, crack sealing, and asphalt repair services in Oklahoma City. Serving commercial properties, HOAs, retail centers, and municipalities.',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Pavement Maintenance Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Parking Lot Striping',
            description: 'Professional line striping and pavement marking services including ADA compliance.',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Sealcoating',
            description: 'High-quality asphalt sealcoating to protect and extend pavement life.',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Crack Sealing',
            description: 'Professional crack repair and sealing to prevent water damage.',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Asphalt Repair',
            description: 'Complete asphalt repair and patching services.',
          },
        },
      ],
    },
  };

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="LocalBusiness" data={localBusinessSchema} />
      <Hero />
      <ServiceGrid />
      <ServiceArea />
      <WhyChoose />
      <RecentWork />
      <QuoteForm />
    </div>
  );
}
